import gql from 'graphql-tag'

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '';
let intermediateCondition = '';
if(cities && cities.length){
  let contractorCities = cities.map(curnt => curnt.city);
  finalCondition = 'contractorAddress: {city: {_in: '+ JSON.stringify(contractorCities) +'}}'
}

export const SUBSCRIBE_TEMPOS = gql`
subscription {
 tempo {
    id
    city
    name
    platNo
    kmLimit
    capacity
    hiringPrice
    extraKmPrice
    type
    status
    Contractor{name id}
    }
  }
 `
export const SUBSCRIBE_TRUCKS = gql`
subscription {
 truck {
    id
    routes
    name
    platNo
    kmLimit
    capacity
    company{
     name
     id
     }
    }
  }
 `
export const SUBSCRIBE_UNOCCUPIED_TRUCKS = gql`
 subscription truck($truckIds: [uuid!], $transporterId: uuid!){
  unOccupiedTrucks: truck(where: {_and: [{ id: {_nin: $truckIds}},{ transporterId: {_eq: $transporterId}}]}) {
    id
    platNo
    name
    }
 }
`
export const SUBSCRIBE_DRIVERS = gql`
subscription driverDetails($driverTypeArr: [Int!]){
 driverDetails (where:{driverType:{_in:$driverTypeArr}}){
    id
    driverType
    Contractor{name id}
    Transporter{name id}
    mobile
    name
    proof
    }
  }
 `
export const SUBSCRIBE_UNOCCUPIED_TRUCK_DRIVERS = gql`
 subscription driverDetails($driverIds: [uuid!]){
  unOccupiedDrivers: driverDetails(where: {_and: [{ id: {_nin: $driverIds}},{ driverType: {_eq: 2}}]}) {
    id
    name
    }
 }
`
export const SUBSCRIBE_CONTRACTORS = gql`
subscription {
 contractor (where: {${finalCondition}, status:{_eq: true} }){
    id
    contractorCode
    name
    type
    mobile
    email
    gstin
    pan
    city
    monthlyKms
    status
    contractorAddress{id add1 add2 area city state pincode}
    }
  }
 `
export const SUBSCRIBE_CONTRACTORS_BY_CITY = gql`
subscription ($selectedCity: String!){
 contractor (where: {contractorAddress: {city: {_eq: $selectedCity}}, status:{_eq: true}}){
    id
    contractorCode
    name
    type
    mobile
    email
    gstin
    pan
    city
    monthlyKms
    contractorAddress{id add1 add2 area city state pincode}
    }
  }
 `
export const SUBSCRIBE_FILTERED_VEHICLES = gql`
 subscription {
  vehicle {
    id
    city
    name
    platNo
    type
    kmLimit
    capacity
    }
 }
`
